
import { useEffect, useState } from 'react';

export default function Footer() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-teal-600 text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute bottom-0 right-0 w-40 h-40 md:w-64 md:h-64">
          <img
            src="https://houjyu-logistics.jp/wp-content/themes/wordpress_theme_v2/images/hero_1.jpg"
            alt=""
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-20 right-4 md:bottom-8 md:right-8 w-10 h-10 md:w-12 md:h-12 bg-black text-white rounded-full flex items-center justify-center hover:bg-gray-800 transition-colors shadow-lg z-50 cursor-pointer"
          aria-label="ページトップへ"
        >
          <i className="ri-arrow-up-line text-lg md:text-xl"></i>
        </button>
      )}

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-8 md:mb-12">
          <div>
            <h3 className="font-bold mb-3 md:mb-4 text-sm md:text-base">企業情報</h3>
            <ul className="space-y-2 text-xs md:text-sm">
              <li>
                <a href="#vision" className="hover:text-gray-200 transition-colors cursor-pointer">
                  企業の思い
                </a>
              </li>
              <li>
                <a href="#company" className="hover:text-gray-200 transition-colors cursor-pointer">
                  会社概要
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-3 md:mb-4 text-sm md:text-base">事業内容</h3>
            <ul className="space-y-2 text-xs md:text-sm">
              <li>
                <a href="#service" className="hover:text-gray-200 transition-colors cursor-pointer">
                  一般貨物運送
                </a>
              </li>
            </ul>
          </div>

          <div className="sm:col-span-2 md:col-span-1">
            <img
              src="https://static.readdy.ai/image/cb8749fdfddc72e72c266efb2e07a84d/4c9aba93a129479dba9f8478425c3679.png"
              alt="宝珠運輸"
              className="h-8 md:h-10 mb-3 md:mb-4 brightness-0 invert"
            />
            <p className="text-xs md:text-sm leading-relaxed mb-4">
              <strong>宝珠運輸株式会社</strong>
              <br />
              〒497-0006
              <br />
              愛知県あま市七宝町下之森一丁田22番、23番
              <br />
              <a
                href="https://maps.app.goo.gl/uhMSREgzN7X6n3GB9"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="underline hover:text-gray-200 transition-colors cursor-pointer"
              >
                VIEW MAP
              </a>
              <br />
              MAIL: info@houjyu-logistics.jp
            </p>
          </div>
        </div>

        <div className="border-t border-white/20 pt-6 md:pt-8 flex flex-col sm:flex-row justify-between items-center gap-3 md:gap-4 text-xs md:text-sm">
          <p>Copyright &copy; 宝珠運輸. All Rights Reserved.</p>

        </div>
      </div>
    </footer>
  );
}
